<template>
  <div class="home">
    <div class="section welcome">
      <oHeroStatic />
      <oSectionOffset>
        <mHowItWorks />
      </oSectionOffset>
      <mOurServices />
      <mReviews />
    </div>
  </div>
</template>

<script>
import oHeroStatic from "../components/organisms/o-hero-static.vue";
import oSectionOffset from "../components/organisms/o-section-offset.vue";
import mHowItWorks from "../components/molecules/m-how-it-works.vue";
import mOurServices from "../components/molecules/m-our-services.vue";
import mReviews from "../components/molecules/m-reviews.vue";

const BASE_URL = "https://jeffbrasov.ro";

export default {
  name: "Home",
  metaInfo() {
    const lang = this.$i18n.locale;
    const pageUrl = `${BASE_URL}/${lang}/`;
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: this.$t("Acasă"),
          item: pageUrl,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: this.$t("faq_home_q1"),
          acceptedAnswer: {
            "@type": "Answer",
            text: this.$t("faq_home_a1"),
          },
        },
        {
          "@type": "Question",
          name: this.$t("faq_home_q2"),
          acceptedAnswer: {
            "@type": "Answer",
            text: this.$t("faq_home_a2"),
          },
        },
        {
          "@type": "Question",
          name: this.$t("faq_home_q3"),
          acceptedAnswer: {
            "@type": "Answer",
            text: this.$t("faq_home_a3"),
          },
        },
        {
          "@type": "Question",
          name: this.$t("faq_home_q4"),
          acceptedAnswer: {
            "@type": "Answer",
            text: this.$t("faq_home_a4"),
          },
        },
        {
          "@type": "Question",
          name: this.$t("faq_home_q5"),
          acceptedAnswer: {
            "@type": "Answer",
            text: this.$t("faq_home_a5"),
          },
        },
      ],
    };
    return {
      title: this.$t("seo_title_home"),
      meta: [
        { name: "description", content: this.$t("meta_desc_home") },
        {
          property: "og:title",
          content: `${this.$t("seo_title_home")} | Mr Jeff Brașov`,
        },
        { property: "og:description", content: this.$t("meta_desc_home") },
        { property: "og:url", content: pageUrl },
        {
          name: "twitter:title",
          content: `${this.$t("seo_title_home")} | Mr Jeff Brașov`,
        },
        { name: "twitter:description", content: this.$t("meta_desc_home") },
      ],
      link: [
        { rel: "canonical", href: pageUrl },
        { rel: "alternate", hreflang: "ro", href: `${BASE_URL}/ro/` },
        { rel: "alternate", hreflang: "en", href: `${BASE_URL}/en/` },
        { rel: "alternate", hreflang: "x-default", href: `${BASE_URL}/ro/` },
      ],
      script: [
        { type: "application/ld+json", json: breadcrumbSchema },
        { type: "application/ld+json", json: faqSchema },
      ],
    };
  },
  components: {
    oHeroStatic,
    oSectionOffset,
    mHowItWorks,
    mOurServices,
    mReviews,
  },
  data() {
    return {};
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";
.home {
  // height: 140vh;
  display: block;
}
</style>
